import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { getDeviationType } from '../../../../_helpers';
import { DeviationTypes } from '../../../../../types/deviation';
import FaveButton from '../../../../../FaveButton';
import OverlayControl from './OverlayControl';
import FavingIcon from '../../../../../FaveButton/FavingIcon';
import { VisuallyHidden } from '../../../../../a11y';
import s from '../Overlay.scss';
var FaveControl = function (_a) {
    var deviation = _a.deviation, className = _a.className, faveCount = _a.faveCount, iconClassName = _a.iconClassName, statClassName = _a.statClassName, size = _a.size, ariaLabel = _a["aria-label"];
    var t = useTranslation().t;
    var deviationType = getDeviationType(deviation);
    var isFaveable = ![
        DeviationTypes.COMMISSION,
        DeviationTypes.POLL,
        DeviationTypes.STATUS,
    ].includes(deviationType);
    if (!isFaveable) {
        return null;
    }
    return (React.createElement(OverlayControl, { stat: faveCount, className: classnames(className), statClassName: statClassName, extraStatContent: React.createElement(VisuallyHidden, null, t('deviationview.overlay.a11y.favouriteStat')) },
        React.createElement(FaveButton, { deviation: deviation, className: classnames(s['icon-button'], deviation.isFavourited && s['active-bg']), "aria-label": ariaLabel }, function (_a) {
            var isFavourite = _a.isFavourite;
            return (React.createElement(FavingIcon, { deviationId: deviation.deviationId, isFavourited: isFavourite, size: size, withPadding: false, disableDefaultColors: true, className: classnames(s['icon'], isFavourite && s['active'], iconClassName) }));
        })));
};
FaveControl.displayName = 'FaveControl';
export default FaveControl;
//# sourceMappingURL=Fave.js.map